

import React, { useState } from 'react';
import Seo from '../components/Seo';
import logo from '../assets/images/vine-centre-logo.png';

function ContactInfoCard() {
  return (
    <div style={{
      flex: '1 1 340px', minWidth: 260, maxWidth: 400,
      background: 'linear-gradient(120deg, #f7e6ee 0%, #e6f7f2 100%)',
      borderRadius: 18, boxShadow: '0 4px 18px rgba(123,30,58,0.10)',
      padding: '2.2em 1.5em', color: '#3a6c5a', fontSize: '1.13rem', fontWeight: 600,
      display: 'flex', flexDirection: 'column', justifyContent: 'center'
    }}>
      <div style={{marginBottom: 22, display: 'flex', alignItems: 'flex-start', gap: 12}}>
        <span style={{fontSize: 22, color: '#7b1e3a', fontWeight: 900}}>&#127968;</span>
        <span>
          <span style={{display: 'block', fontWeight: 700, color: '#7b1e3a'}}>Address:</span>
          Vine Centre<br />
          193 Crumlin Road<br />
          Belfast<br />
          BT14 7DX
        </span>
      </div>
      <div style={{marginBottom: 22, display: 'flex', alignItems: 'center', gap: 12}}>
        <span style={{fontSize: 22, color: '#7b1e3a', fontWeight: 900}}>&#128222;</span>
        <span>
          <span style={{display: 'block', fontWeight: 700, color: '#7b1e3a'}}>Telephone:</span>
          <a href="tel:02890351020" style={{color: '#3a6c5a', textDecoration: 'underline'}}>028 9035 1020</a>
        </span>
      </div>
      <div style={{marginBottom: 22, display: 'flex', alignItems: 'center', gap: 12}}>
        <span style={{fontSize: 22, color: '#7b1e3a', fontWeight: 900}}>&#128224;</span>
        <span>
          <span style={{display: 'block', fontWeight: 700, color: '#7b1e3a'}}>Fax:</span>
          028 9035 5658
        </span>
      </div>
      <div style={{display: 'flex', alignItems: 'center', gap: 12}}>
        <span style={{fontSize: 22, color: '#7b1e3a', fontWeight: 900}}>&#9993;</span>
        <span>
          <span style={{display: 'block', fontWeight: 700, color: '#7b1e3a'}}>Email:</span>
          <a href="mailto:info@vinecentre.org" style={{color: '#3a6c5a', textDecoration: 'underline'}}>info@vinecentre.org</a>
        </span>
      </div>
    </div>
  );
}

function ContactForm() {
  const [form, setForm] = useState({ name: '', email: '', message: '' });
  const handleChange = e => {
    const { name, value } = e.target;
    setForm(f => ({ ...f, [name]: value }));
  };
  const mailtoHref = `mailto:info@vinecentre.org?subject=Contact from ${encodeURIComponent(form.name)}&body=${encodeURIComponent(form.message + '\n\nFrom: ' + form.name + ' (' + form.email + ')')}`;
  return (
    <form
      style={{
        flex: '1 1 340px', minWidth: 260, maxWidth: 400,
        background: '#fff', borderRadius: 18, boxShadow: '0 4px 18px rgba(123,30,58,0.10)',
        padding: '2.2em 1.5em', color: '#3a6c5a', fontWeight: 600,
        display: 'flex', flexDirection: 'column', justifyContent: 'center'
      }}
      action={mailtoHref}
      method="GET"
      onSubmit={e => {
        if (!form.name || !form.email || !form.message) {
          e.preventDefault();
          alert('Please fill in all fields.');
        }
      }}
    >
      <h3 style={{color: '#7b1e3a', fontWeight: 900, fontSize: '1.15rem', marginBottom: 18}}>Send us an Email</h3>
      <div style={{marginBottom: 16}}>
        <label htmlFor="name" style={{display: 'block', fontWeight: 700, marginBottom: 4}}>Name</label>
        <input type="text" id="name" name="name" value={form.name} onChange={handleChange} required style={{width: '100%', padding: 8, borderRadius: 6, border: '1px solid #ccc', fontSize: '1rem'}} />
      </div>
      <div style={{marginBottom: 16}}>
        <label htmlFor="email" style={{display: 'block', fontWeight: 700, marginBottom: 4}}>Email</label>
        <input type="email" id="email" name="email" value={form.email} onChange={handleChange} required style={{width: '100%', padding: 8, borderRadius: 6, border: '1px solid #ccc', fontSize: '1rem'}} />
      </div>
      <div style={{marginBottom: 18}}>
        <label htmlFor="message" style={{display: 'block', fontWeight: 700, marginBottom: 4}}>Message</label>
        <textarea id="message" name="message" value={form.message} onChange={handleChange} required rows={5} style={{width: '100%', padding: 8, borderRadius: 6, border: '1px solid #ccc', fontSize: '1rem', resize: 'vertical'}} />
      </div>
      <button type="submit" style={{background: '#7b1e3a', color: '#fff', fontWeight: 700, border: 'none', borderRadius: 8, padding: '0.7em 2em', fontSize: '1.08rem', cursor: 'pointer'}}>Send Email</button>
    </form>
  );
}

function ContactMap() {
  return (
    <div style={{width: '100%', maxWidth: 900, background: '#fff', borderRadius: 18, boxShadow: '0 4px 18px rgba(123,30,58,0.10)', overflow: 'hidden'}}>
      <iframe
        title="Vine Centre Location"
        src="https://www.google.com/maps?q=Vine+Centre,+193+Crumlin+Road,+Belfast+BT14+7DX,+UK&output=embed"
        width="100%"
        height="340"
        style={{border: 0, width: '100%', display: 'block'}}
        allowFullScreen=""
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
      ></iframe>
    </div>
  );
}


function Contact() {
  return (
    <>
      <Seo
        title="Contact the Vine Centre | Get in Touch, North Belfast"
        description="Contact the Vine Centre in North Belfast. Find our address, phone, email, and send us a message. View our location on the map."
      />
      <section id="contact" style={{maxWidth: 1100, margin: '0 auto', padding: '2.5em 1em'}}>
        <div style={{textAlign: 'center', marginBottom: 24}}>
          <img src={logo} alt="Vine Centre Logo" style={{display: 'inline-block', margin: '0 auto 12px auto', maxWidth: 110, maxHeight: 110, borderRadius: 18, boxShadow: '0 2px 12px #7b1e3a22'}} />
          <h2 style={{color: '#7b1e3a', fontWeight: 900, fontSize: '2.2rem', margin: 0, letterSpacing: 1}}>Contact Us</h2>
          <div style={{color: '#3a6c5a', fontSize: '1.13rem', marginTop: 8, marginBottom: 0, fontWeight: 600}}>We'd love to hear from you. Reach out by phone, email, or the form below!</div>
        </div>
        <div style={{display: 'flex', flexWrap: 'wrap', gap: 36, justifyContent: 'center', alignItems: 'stretch', marginBottom: 40}}>
          <ContactInfoCard />
          <ContactForm />
        </div>
        <div style={{marginTop: 36, display: 'flex', justifyContent: 'center'}}>
          <ContactMap />
        </div>
      </section>
    </>
  );
}

export default Contact;
